module.exports = __webpack_public_path__ + "img/player-img-05.60419549.png";